import {
  USER_TOKEN_SS_KEY,
  REFRESH_TOKEN_SS_KEY,
  USER_EXPIRATION_TIME_SS_KEY,
} from '../../configs/app.config';
import { isClient } from '../next/next.util';

export const isLogged = (): boolean =>
  isClient() &&
  !!sessionStorage.getItem(USER_TOKEN_SS_KEY) &&
  !!sessionStorage.getItem(REFRESH_TOKEN_SS_KEY);

export const getTokenExpiration = (): number => {
  const expiration = sessionStorage.getItem(USER_EXPIRATION_TIME_SS_KEY);

  if (typeof expiration === 'string') {
    return parseInt(expiration, 10);
  }

  return 0;
};

/**
 * Checks if the token has expired
 *
 *  @returns True if expire, fale if note, undefined if expiration no exist
 */
export const checkUserTokenExpire = (): boolean | undefined => {
  const expiration = getTokenExpiration();

  if (expiration) {
    return Date.now() >= expiration * 1000;
  }

  return undefined;
};
